/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-15 11:28:22
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import { useCallback, useEffect } from 'react';
import shallow from 'zustand/shallow';
import { useUiState } from '@state';
import { isInApp } from '@shared';
import native from '@native';
import { UI } from '@root/constant';

const useSafeAreaInsets = () => {
  const { loaded, ui, setUi } = useUiState(
    (state) => ({
      ui: state.ui,
      loaded: state.loaded,
      setUi: state.setUi,
    }),
    shallow,
  );

  // 获取顶部安全高度
  const getSafeArea = useCallback(async () => {
    try {
      const { data } = (await native.system.getSafeAreaInsets()) || {};
      const _data = {
        top: data.top || 0,
        bottom: data.bottom || 0,
      };
      setUi(_data);
      window.localStorage.setItem(UI, JSON.stringify(_data));
    } catch (error) {}
  }, [setUi]);

  useEffect(() => {
    if (isInApp && window.WebViewJavascriptBridge && !loaded) {
      getSafeArea();
    }
  }, [getSafeArea, loaded, ui.bottom]);

  return {
    top: ui.top,
    bottom: ui.bottom,
  };
};

export default useSafeAreaInsets;
